import * as _ from 'lodash';
import memoize from 'memoize-one';

export interface FormRadioOption {
  value: string;
  label?: string;
  explanationText?: string;
  icon?: any;
}

export type FormRadioOptions = Array<FormRadioOption>;

export interface FormSelectOption {
  value: string | number;
  label?: string;
  explanationText?: string;
  icon?: any;
}
export type FormSelectOptions = Array<FormSelectOption>;

export type OrderByPropType = {
  iteratees: _.Many<keyof (FormSelectOption | FormRadioOption)>;
  orders: _.Many<'asc' | 'desc'>;
};

export const LABEL_ASC: OrderByPropType = {iteratees: 'label', orders: 'asc'};

export function createGetOrderedOptions<Options extends FormRadioOptions | FormSelectOptions>(): (
  orderBy: OrderByPropType,
  options: Options
) => Options {
  return memoize((orderBy: OrderByPropType, options: Options) => {
    if (orderBy) {
      return _.orderBy(options, orderBy.iteratees, orderBy.orders) as Options;
    }
    return options;
  });
}
